var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayerEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2015 16.1992H2.78349C2.36723 16.1992 2.02979 16.5367 2.02979 16.9529V16.953C2.02979 17.3692 2.36723 17.7067 2.78349 17.7067H20.2015C20.6177 17.7067 20.9552 17.3692 20.9552 16.953V16.9529C20.9552 16.5367 20.6177 16.1992 20.2015 16.1992Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2313 19.0352H1.7835C1.36723 19.0352 1.02979 19.3726 1.02979 19.7889V19.7889C1.02979 20.2052 1.36723 20.5426 1.7835 20.5426H21.2313C21.6476 20.5426 21.985 20.2052 21.985 19.7889V19.7889C21.985 19.3726 21.6476 19.0352 21.2313 19.0352Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2463 22.0117H0.75371C0.337447 22.0117 0 22.3492 0 22.7654V22.7655C0 23.1817 0.337447 23.5192 0.75371 23.5192H22.2463C22.6626 23.5192 23 23.1817 23 22.7655V22.7654C23 22.3492 22.6626 22.0117 22.2463 22.0117Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16251 10.4375H3.02453C2.88747 10.4375 2.77637 10.5486 2.77637 10.6857V16.1669C2.77637 16.304 2.88747 16.4151 3.02453 16.4151H4.16251C4.29956 16.4151 4.41067 16.304 4.41067 16.1669V10.6857C4.41067 10.5486 4.29956 10.4375 4.16251 10.4375Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17716 10.4375H8.03917C7.90212 10.4375 7.79102 10.5486 7.79102 10.6857V16.1669C7.79102 16.304 7.90212 16.4151 8.03917 16.4151H9.17716C9.31421 16.4151 9.42532 16.304 9.42532 16.1669V10.6857C9.42532 10.5486 9.31421 10.4375 9.17716 10.4375Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9198 10.4375H13.7819C13.6448 10.4375 13.5337 10.5486 13.5337 10.6857V16.1669C13.5337 16.304 13.6448 16.4151 13.7819 16.4151H14.9198C15.0569 16.4151 15.168 16.304 15.168 16.1669V10.6857C15.168 10.5486 15.0569 10.4375 14.9198 10.4375Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9682 10.4375H18.8302C18.6931 10.4375 18.582 10.5486 18.582 10.6857V16.1669C18.582 16.304 18.6931 16.4151 18.8302 16.4151H19.9682C20.1052 16.4151 20.2163 16.304 20.2163 16.1669V10.6857C20.2163 10.5486 20.1052 10.4375 19.9682 10.4375Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3045 3.91406C9.92795 3.91406 8.81201 4.94118 8.81201 6.20818C8.81201 7.47518 9.92795 8.50224 11.3048 8.50224C12.6817 8.50224 13.7973 7.47513 13.7973 6.20818C13.7973 4.94123 12.6811 3.91406 11.3045 3.91406ZM11.3045 7.68464C10.4184 7.68464 9.70029 7.0236 9.70029 6.20818C9.70029 5.39276 10.4184 4.73177 11.3045 4.73177C12.1906 4.73177 12.9088 5.39282 12.9088 6.20829C12.9088 7.02376 12.1906 7.68464 11.3045 7.68464Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.266894,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1769 8.36379H1.36759C0.843358 8.36379 0.635554 7.68534 1.06979 7.39171L5.40448 4.46083L10.8791 0.759169C10.967 0.699731 11.0707 0.667969 11.1769 0.667969C11.283 0.667969 11.3867 0.699731 11.4747 0.759169L16.9493 4.46083L21.2839 7.39171C21.7182 7.68529 21.5104 8.36379 20.9861 8.36379H11.1769Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.33447,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23.5205,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayerEnrollment);
export default __webpack_public_path__ + "static/media/payerEnrollment.1695bce15a0f13bc05dd249a883b3c2c.svg";
export { ForwardRef as ReactComponent };